'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { Stamp } from '@src/components/TopNavV5/Stamp'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import type { TopNavV5SubMenu } from '@src/components/TopNavV5/TopNavV5Props'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'
import { cn } from '@src/utils/tailwind'

export const TopNavV5MobileLeftMenu = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { mobileDispatch, mobileState } = useTopNavV5()

  const itemClasses = 'py-3 text-heading-4 font-lateral font-medium text-left'

  const renderTitle = (menu: TopNavV5SubMenu) => (
    <div className="flex w-fit items-center gap-2">
      {menu.title}
      <Stamp text={menu.stamp} />
    </div>
  )

  if (mobileState.state !== 'left-menu-open') return null
  const items = mobileState.leftMenu?.items

  return (
    <div>
      <div className="flex h-14 items-center border-b border-white/10 p-4">
        <button
          onClick={() => {
            mobileDispatch({ type: 'BACK_FROM_LEFT_MENU' })
          }}
          className="flex items-center gap-2"
        >
          <ChevronLeftIcon className="size-5 text-bodi-green-bright-500" />
          <p className="text-heading-4 text-left font-lateral">{mobileState.leftMenu?.title}</p>
          <Stamp text={mobileState.leftMenu?.stamp} />
        </button>
      </div>
      <div className="flex flex-col gap-2 px-4 py-6 pt-4">
        {items?.map((item, index) => {
          if (item.isLink) {
            return (
              <LocalizedLink
                onClick={() => {
                  trackSelectNavCta({ 'cta url': item.link?.href ?? '' })
                  mobileDispatch({ type: 'CLOSE_FROM_MAIN' })
                }}
                data-testid={`nav-menu-${index}`}
                key={`${item.title}-${index}`}
                className={itemClasses}
                href={item.link?.href ?? ''}
                rel={item.link?.newTab ? 'noopener noreferrer' : ''}
                target={item.link?.newTab ? '_blank' : '_self'}
              >
                {renderTitle(item)}
              </LocalizedLink>
            )
          }

          return (
            <button
              data-testid={`nav-menu-${index}`}
              key={`${item.title}-${index}`}
              className={cn(
                itemClasses,
                'relative flex w-full cursor-pointer items-center gap-2 transition-all'
              )}
              onClick={() => {
                mobileDispatch({
                  type: 'OPEN_LEFT_MENU_SUB_MENU',
                  payload: { leftMenuIndex: index },
                })
              }}
            >
              {renderTitle(item)}
              <ChevronRightIcon className="size-5 text-bodi-green-bright-500" />
            </button>
          )
        })}
      </div>
    </div>
  )
}
